import size from '@/assets/theme/size';
import getDropdownId from '@/state/selectors/navigation/get-dropdown-id';
import getOpenState from '@/state/selectors/navigation/get-open-state';
import isCurrentWidthWiderThan from '@/state/selectors/window/is-current-width-wider-than';
import { IStore } from '@/state/slices/typings';
import NaasHelper from '@/utils/naas-helper';
import { NaasEvent } from '@/utils/naas-helper/enum';

const handleVehicleDropdownOpen = (prevState: IStore, nextState: IStore) => {
	const nextOpenState = getOpenState(nextState);
	const prevDropdownId = getDropdownId(prevState);
	const dropdownId = getDropdownId(nextState);
	const isDesktop = isCurrentWidthWiderThan(nextState, size.laptop);

	if (
		nextOpenState &&
		prevDropdownId !== 'vehicles' &&
		dropdownId === 'vehicles' &&
		isDesktop
	) {
		NaasHelper.dispatchEvent(NaasEvent.VEHICLE_DROPDOWN_OPEN);
	}
};

export default handleVehicleDropdownOpen;
